import React from 'react';

import spinnerGif from './spinner.gif';
import * as S from './styles';

export type TProps = {
  color?: string;
  className?: string;
  size?: string | number;
  extention?: 'svg' | 'gif';
};

const Spinner = React.memo<TProps>(
  ({className, size = '32px', extention = 'svg', color = 'currentColor'}) => {
    if (extention === 'gif') {
      return <S.SpinnerGifImg role="progressbar" src={spinnerGif} alt="loading..." />;
    }

    return (
      <S.Spinner
        role="progressbar"
        width={size}
        height={size}
        viewBox="0 0 50 50"
        className={className}
        xmlns="http://www.w3.org/2000/svg"
      >
        <S.Circle
          fill="transparent"
          stroke={color}
          strokeWidth="4"
          strokeLinecap="round"
          cx="25"
          cy="25"
          r="20"
        />
      </S.Spinner>
    );
  },
);

export default Spinner;
export {Spinner};
